var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"mx-1"},[_c('span',{staticClass:"badge badge-light"},[_vm._v(_vm._s(_vm.keyword))])])}
var staticRenderFns = []

export { render, staticRenderFns }